import { markRaw } from 'vue';

import { createPinia, Pinia } from 'pinia';

// Gives every Pinia store access to the running Application instance
// (API clients, config) as `this.$app` — the same object the legacy
// vue-commons store factories received as their `app` argument.
export function createAppPinia(application: unknown): Pinia {
    const pinia = createPinia();
    pinia.use(({ store }) => {
        // markRaw because a store is reactive, and anything assigned into it is
        // otherwise handed back as a reactive proxy — which auto-unwraps refs on
        // property access. That silently turned `$app.router.currentRoute` (a Ref
        // under vue-router 4) into the route object, making `.value` undefined.
        // The application is a service locator (API clients, router, config), never
        // reactive state, so there is nothing to gain from wrapping it.
        store.$app = markRaw(application as object);
    });
    return pinia;
}

declare module 'pinia' {
    export interface PiniaCustomProperties {
        // Loosely typed on purpose: the concrete Application type is generic per
        // app. Store modules declare their own requirement interfaces and cast,
        // exactly like the legacy vue-commons store factories' `app` argument.
        $app: any;
    }
}
